import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {PaymentService, SubscriptionDetailsDto} from "../../api";
import {CancelSubscriptionComponent} from "../cancel-subscription/cancel-subscription.component";

@Component({
  selector: 'app-edit-subscription',
  templateUrl: './edit-subscription.component.html',
  styleUrl: './edit-subscription.component.scss'
})
export class EditSubscriptionComponent implements OnInit {

  data : SubscriptionDetailsDto = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialog_data: string,
    protected dialogRef : MatDialogRef<EditSubscriptionComponent>,
    protected paymentService: PaymentService,
    protected dialog : MatDialog
    ) {  }

  ngOnInit() {
    this.paymentService.getSubscriptionInfoEndpoint().subscribe(data => {
      this.data = data;
    })
  }

  /** DOCU-1042: Testphase läuft — Bezahltarif ohne Stripe-Abo dahinter. */
  get isTrial(): boolean {
    return this.data.isTrial === true;
  }

  /**
   * Resttage, nie negativ dargestellt. Ist die Testphase abgelaufen, ohne dass gebucht
   * wurde, bleibt der Zugang bestehen (Entscheidung 16.09.2026) — dann steht 0 da und der
   * Hinweistext wechselt, statt eine negative Zahl anzuzeigen.
   */
  get trialDaysLeft(): number {
    return Math.max(this.data.trialDaysLeft ?? 0, 0);
  }

  /** Enddatum liegt in der Vergangenheit, es wurde aber nicht gebucht. */
  get isTrialExpired(): boolean {
    return this.isTrial && (this.data.trialDaysLeft ?? 0) <= 0;
  }

  /**
   * Das Datum, das im Feld neben der Nutzerzahl steht — Trial-Ende oder Abrechnungstermin.
   *
   * Muss ein Getter sein und darf keine Template-Bedingung bleiben: Im Trial-Fall liefert
   * die API `nextBillingDate` **überhaupt nicht** (in GetUserSubscriptionDetails wird es im
   * Trial-Zweig nicht gesetzt, bleibt also null). Ein Template, das dort weiter
   * `nextBillingDate` rendert, zeigt unter der Überschrift „Testphase endet am" ein leeres
   * Feld. Genau so war es in der ersten Fassung dieses Tickets.
   */
  get periodEndDate(): string | null | undefined {
    return this.isTrial ? this.data.trialEndsAt : this.data.nextBillingDate;
  }

  onCancelClick(): void {
    const dialogRef = this.dialog.open(CancelSubscriptionComponent, {
      width: '700px',
      maxWidth: '90vw',
      data: ""
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'cancelled') {
        this.dialogRef.close('reload');
      }
    })
  }

  onModifyClick(): void {
    this.dialogRef.close({ action: 'modify', lookupKey: this.data.lookupKey });
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }
}


